import { Chart as ChartJS } from 'chart.js';
import WidgetService from '../widgetService/WidgetService';
import { ChartDataLabelsTypeEnum } from '../../models/ChartDataLabelsTypeEnum';

export const colorArray = ['#B7CFCE', '#D8C0D4', '#C2C7D6', '#C6BEDA', '#CFCCB0', '#CFB0B0', '#EADCAB', '#CECACA', '#BEADEB'];

const fetchChartData = async (customerUuid, chartResourceId, setChartData, setNewSelectedWidgetData, isEditorOpen, signal) => {
    if (customerUuid && chartResourceId && !isEditorOpen) {
        try {
            const responseData = await WidgetService.getSelectedResourceData(customerUuid, chartResourceId, { signal });
            setNewSelectedWidgetData({
                chartData: responseData.data,
            });
            setChartData(responseData.data);
        } catch (error) {
            console.error('Error fetching chart data:', error);
        }
    }
};

export const prepareChartData = (chartData, t) => {
    if (!chartData || (!chartData?.labels && !chartData?.datasets)) {
        return null; // Indicates no data
    } else {
        const getLabel = (label) => {
            switch (chartData?.labelsType) {
                case ChartDataLabelsTypeEnum.WEEKDAYS:
                    const dayNames = [
                        t('COMMON.WEEKDAY_MONDAY_TEXT'),
                        t('COMMON.WEEKDAY_TUESDAY_TEXT'),
                        t('COMMON.WEEKDAY_WEDNESDAY_TEXT'),
                        t('COMMON.WEEKDAY_THURSDAY_TEXT'),
                        t('COMMON.WEEKDAY_FRIDAY_TEXT'),
                        t('COMMON.WEEKDAY_SATURDAY_TEXT'),
                        t('COMMON.WEEKDAY_SUNDAY_TEXT'),
                    ];
                    const intLabel = parseInt(label, 10);
                    return dayNames[intLabel % 7];
                default:
                    return label;
            }
        };

        const resourceLabels = chartData?.labels?.map(getLabel) || [];
        const resourceDatasets = chartData?.datasets ? JSON.parse(JSON.stringify(chartData?.datasets)) : [];
        return {
            labels: resourceLabels,
            datasets: resourceDatasets.map((dataset, index) => ({
                label: t(`CHART_DATA.${dataset.label.toUpperCase()}`),
                data: dataset.data,
                fill: true,
                borderColor: colorArray[index % colorArray.length],
                backgroundColor: colorArray[index % colorArray.length], // For bar charts, use backgroundColor
            })),
        };
    }
};

const ChartService = {
    fetchChartData,
    prepareChartData,
};

export default ChartService;
